import { render, staticRenderFns } from "./SliceTextbodyImage.vue?vue&type=template&id=a06e5d36&lang=pug&"
import script from "./SliceTextbodyImage.vue?vue&type=script&lang=js&"
export * from "./SliceTextbodyImage.vue?vue&type=script&lang=js&"
import style0 from "./SliceTextbodyImage.vue?vue&type=style&index=0&id=a06e5d36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports